import VueRouter from 'vue-router'

import Index from '../components/Index.vue'
import NotFound from '../components/NotFound.vue'

import { EventBus }   from './main'
import { capitalize } from './helpers/utils'

let context = require.context('../components/single', true, /\.(vue)$/)


let pagination = []

let routes = [
    { path: '/', name: 'index', component: Index },
    { path: '*', component: NotFound }
]

context.keys().forEach(filename => {

    let suffix = filename.indexOf('.vue'),
        file = filename.substr(2, suffix - 2),
        path = '/' + file.replace(/\s+/g, '-')

    pagination.push(path)

    let route = {
        path,
        component: context(filename),
        meta: { scrollToTop: true }
    }

    routes.unshift(route)

})


// Save Scroll Position
const scrollBehavior = (to, from, savedPosition) => {

    if( savedPosition ) return savedPosition

    let position = {}

    if( to.matched.some(m => m.meta.scrollToTop) ) {
        position.x = 0
        position.y = 0
    }

    return position
}

// Set name for route if not single
const router = new VueRouter({
    routes,
    mode: 'history',
    scrollBehavior
})


module.exports = { router, pagination }



// WEBPACK FOOTER //
// ./js/router.js